import Page from 'rui/widgets/Page'
import Thin from 'components/layout/Thin'
import Panel, { PanelHeading, PanelSubheading } from 'components/layout/Panel'
import duplicateAccount from 'images/duplicate-account.png'
import { Image, Spacer, Text } from 'roadie-ui'
import { useLocalization } from 'localization'

const DuplicateAccount = () => {
  const { t } = useLocalization()

  return (
    <Page>
      <Thin>
        <Panel>
          <PanelHeading>{t('dweb_duplicate_account_heading')}</PanelHeading>
          <PanelSubheading>{t('dweb_duplicate_account_subheading')}</PanelSubheading>
          <Spacer $height="1.6rem" />
          <Image width="50%" src={duplicateAccount} />
          <Spacer $height="1.6rem" />
          <Text.Body2 $textAlign="left" $color="neutral-black">
            {t('dweb_duplicate_account_account_limit_body')}
          </Text.Body2>
          <Spacer $height="1.6rem" />
          <Text.Body2 $textAlign="left" $color="neutral-black">
            {t('dweb_duplicate_account_reset_password_body')}
          </Text.Body2>
          <Spacer $height="1.6rem" />
        </Panel>
      </Thin>
    </Page>
  )
}

export default DuplicateAccount
